import { useCallback, useContext } from 'react';
import { Divider, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import useMenu from 'shared/hooks/use-menu';
import { Link, useHistory } from 'react-router-dom';
import { UserContext } from 'shared/Providers/User';
import { r } from 'shared/constants/routes';
import UserAvatar from 'shared/Pages/common/Header/AccountMenu/avatar';

type LogoutMenuItemProps = {
  handleClose: () => void
}
function LogoutMenuItem({ handleClose }: LogoutMenuItemProps): JSX.Element {
	const { logout } = useContext(UserContext);
	const history = useHistory();

	const onClick = useCallback(async () => {
		handleClose();
		await logout();
		history.push(r.login.path);
	}, [history, logout]);

	return <MenuItem onClick={onClick}>Logout</MenuItem>;
}

export default function AccountMenu() {
	const { user } = useContext(UserContext);
	const { anchorEl, open, handleOpen, handleClose } = useMenu();

	return (
		<>
			<Tooltip title="Account settings" placement="bottom-end">
				<IconButton onClick={handleOpen}>
					<UserAvatar name={user?.name || user?.email} />
				</IconButton>
			</Tooltip>
			<Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
				<Typography color="secondary" px={4} py={1.5}>
					{user?.name || user?.email}
				</Typography>
				<Divider />
				<MenuItem component={Link} to={r.account.path} onClick={handleClose}>
					Account
				</MenuItem>
				<LogoutMenuItem handleClose={handleClose} />
			</Menu>
		</>
	);
}
